import React, { Component } from 'react';
//styles
import { IconBox } from './style';
import Lock from '../../../Assets/Icons/lock.svg';
import Delete from '../../../Assets/Icons/icon-delete.svg';
import Pushup from '../../../Assets/Icons/pushup.svg';
import Logo from '../../../Assets/Images/Logo/logo.svg';
import SmallLogo from '../../../Assets/Images/Logo/smLogo.svg';
import Trophy from '../../../Assets/Icons/trophy.svg';
import Close from '../../../Assets/Icons/close.svg';

import CheckOutline from '../../../Assets/Icons/check-outline.png';
import CheckFull from '../../../Assets/Icons/check-full.png';

import OvalGreen from '../../../Assets/Icons/oval-2.svg';
import LogoBage from '../../../Assets/Images/Logo/logoBage.svg';

import Arrow from '../../../Assets/Icons/arrow-copy-1.svg';
import Shield from '../../../Assets/Icons/shield.svg';
import FakeUserPhoto from '../../../Assets/Icons/default-user.svg';

import UnHeppy from '../../../Assets/Icons/unhappy.svg';

// leaderboards
import Headerate from '../../../Assets/Icons/LeaderboardIcons/heartrate.png';
import Hype from '../../../Assets/Icons/LeaderboardIcons/hype.png';
import Time from '../../../Assets/Icons/LeaderboardIcons/time.png';
import Record from '../../../Assets/Icons/LeaderboardIcons/record.png';
import Weight from '../../../Assets/Icons/LeaderboardIcons/weight.png';
import Reps from '../../../Assets/Icons/LeaderboardIcons/reps.png';
import Repeat from '../../../Assets/Icons/LeaderboardIcons/repeat.png';
import Calories from '../../../Assets/Icons/LeaderboardIcons/calories.png';
import SadIcon from '../../../Assets/Icons/unhappy.png';
import Join from '../../../Assets/Icons/Gymtv/add.png';

import AppStoreLogo from '../../../Assets/Images/app-store-en-white.png';
import AppStoreBlackLogo from '../../../Assets/Images/tona-app-store@3x.png';
import GooglePlayLogo from '../../../Assets/Images/play-store-en-white.png';
import GooglePlayComingSoonLogo from '../../../Assets/Images/tona-google-play@3x.png';

import CheckEmail from '../../../Assets/Icons/check-email.svg';
import SearchLoop from '../../../Assets/Icons/Search/Search.svg';
import SearchCloseIcon from '../../../Assets/Icons/Search/Close.svg';
import SearchNotFound from '../../../Assets/Icons/Search/Unhappy.svg';
import SearchUserDefaultImage from '../../../Assets/Icons/no-image-gym.svg';
import Settings from '../../../Assets/Icons/settings-cog.svg';
import Edit from '../../../Assets/Icons/edit.png';
import Copy from '../../../Assets/Icons/copy.svg';
import ArrowUp from '../../../Assets/Icons/arrow-up.svg';
import ArrowDown from '../../../Assets/Icons/arrow-down.svg';
import Celebrate from '../../../Assets/Icons/Gymtv/celebrate.svg';
import NoWatch from '../../../Assets/Icons/Gymtv/apple-watch-none.svg';

// gym tv
import HeartratePercentWhite from '../../../Assets/Icons/Gymtv/heartrate-percent-1.png';
import HeartratePercentPurple from '../../../Assets/Icons/Gymtv/heartrate-percent-2.png';
import HeartratePercentBlue from '../../../Assets/Icons/Gymtv/heartrate-percent-3.png';
import HeartratePercentGreen from '../../../Assets/Icons/Gymtv/heartrate-percent-4.png';
import HeartratePercentOrange from '../../../Assets/Icons/Gymtv/heartrate-percent-5.png';
import HeartratePercentRed from '../../../Assets/Icons/Gymtv/heartrate-percent-6.png';

import CaloriesWhite from '../../../Assets/Icons/Gymtv/calories-1.png';
import CaloriesPurple from '../../../Assets/Icons/Gymtv/calories-2.png';
import CaloriesBlue from '../../../Assets/Icons/Gymtv/calories-3.png';
import CaloriesGreen from '../../../Assets/Icons/Gymtv/calories-4.png';
import CaloriesOrange from '../../../Assets/Icons/Gymtv/calories-5.png';
import CaloriesRed from '../../../Assets/Icons/Gymtv/calories-6.png';

import HeartrateWhite from '../../../Assets/Icons/Gymtv/heartrate-1.png';
import HeartratePurple from '../../../Assets/Icons/Gymtv/heartrate-2.png';
import HeartrateBlue from '../../../Assets/Icons/Gymtv/heartrate-3.png';
import HeartrateGreen from '../../../Assets/Icons/Gymtv/heartrate-4.png';
import HeartrateOrange from '../../../Assets/Icons/Gymtv/heartrate-5.png';
import HeartrateRed from '../../../Assets/Icons/Gymtv/heartrate-6.png';

import Aerobics from '../../../Assets/Icons/WorkoutType/Aerobics.png';
import AnimalMovement from '../../../Assets/Icons/WorkoutType/AnimalMovement.png';
import Barre from '../../../Assets/Icons/WorkoutType/Barre.png';
import Bodyweight from '../../../Assets/Icons/WorkoutType/Bodyweight.png';
import Bootcamp from '../../../Assets/Icons/WorkoutType/Bootcamp.png';
import Boxing from '../../../Assets/Icons/WorkoutType/Boxing.png';
import Calisthenics from '../../../Assets/Icons/WorkoutType/Calisthenics.png';
import Cardio from '../../../Assets/Icons/WorkoutType/Cardio.png';
import CircuitTraining from '../../../Assets/Icons/WorkoutType/CircuitTraining.png';
import Conditioning from '../../../Assets/Icons/WorkoutType/Conditioning.png';
import Core from '../../../Assets/Icons/WorkoutType/Core.png';
import Crossfit from '../../../Assets/Icons/WorkoutType/Crossfit.png';
import Cycling from '../../../Assets/Icons/WorkoutType/Cycling.png';
import Gym from '../../../Assets/Icons/WorkoutType/Gym.png';
import HIIT from '../../../Assets/Icons/WorkoutType/HIIT.png';
import Kettlebell from '../../../Assets/Icons/WorkoutType/Kettlebell.png';
import MartialArts from '../../../Assets/Icons/WorkoutType/MartialArts.png';
import Military from '../../../Assets/Icons/WorkoutType/Military.png';
import Other from '../../../Assets/Icons/WorkoutType/Other.png';
import Pilates from '../../../Assets/Icons/WorkoutType/Pilates.png';
import Rowing from '../../../Assets/Icons/WorkoutType/Rowing.png';
import Running from '../../../Assets/Icons/WorkoutType/Running.png';
import Spinning from '../../../Assets/Icons/WorkoutType/Spinning.png';
import StrengthTraining from '../../../Assets/Icons/WorkoutType/StrengthTraining.png';
import Stretching from '../../../Assets/Icons/WorkoutType/Stretching.png';
import Strongman from '../../../Assets/Icons/WorkoutType/Strongman.png';
import Swimming from '../../../Assets/Icons/WorkoutType/Aerobics.png';
import Tabata from '../../../Assets/Icons/WorkoutType/Tabata.png';
import TRX from '../../../Assets/Icons/WorkoutType/Aerobics.png';
import Walking from '../../../Assets/Icons/WorkoutType/Aerobics.png';
import WaterAerobics from '../../../Assets/Icons/WorkoutType/WaterAerobics.png';
import WeightTraining from '../../../Assets/Icons/WorkoutType/WeightTraining.png';
import Yoga from '../../../Assets/Icons/WorkoutType/Yoga.png';

import CaretRight from '../../../Assets/Icons/caret-right@3x.png';
import CaretLeft from '../../../Assets/Icons/icon-caret-left@3x.png';
import CheckOrange from '../../../Assets/Icons/check-orange.svg';

// workout types

export class Icon extends Component {
    static Box = props => <IconBox {...props} />;

    static Headerate = props => <img alt={'Heart rate'} src={Headerate} />;
    static Hype = props => <img alt={'Hype'} src={Hype} />;
    static Time = props => <img alt={'Time'} src={Time} />;
    static Record = props => <img alt={'Record'} src={Record} />;
    static Weight = props => <img alt={'Weight'} src={Weight} />;
    static Reps = props => <img alt={'Reps'} src={Reps} />;
    static Repeat = props => <img alt={'Repeat'} src={Repeat} />;
    static Calories = props => <img alt={'Calories'} src={Calories} />;
    static SadIcon = props => <img alt={'Sad Icon'} src={SadIcon} />;
    static Join = props => <img alt={'Join'} src={Join} />;
    static Edit = props => <img alt={'Edit'} src={Edit} />;

    static Lock = props => <Lock {...props} />;
    static Delete = props => <Delete {...props} />;
    static Logo = props => <Logo {...props} />;
    static SmallLogo = props => <SmallLogo {...props} />;
    static Trophy = props => <Trophy {...props} />;
    static Pushup = props => <Pushup {...props} />;
    static Close = props => <Close {...props} />;

    static CheckOutline = props => <CheckOutline {...props} />;
    static CheckFull = props => <CheckFull {...props} />;

    static OvalGreen = props => <OvalGreen {...props} />;
    static LogoBage = props => <LogoBage {...props} />;
    static Shield = props => <Shield {...props} />;
    static ArrowUp = props => <Arrow {...props} />;

    static UnHeppy = props => <UnHeppy {...props} />;

    static FakeImageAvatar = props => <FakeUserPhoto {...props} />;

    static AppStoreLogo = props => <img alt={'App Store'} src={AppStoreLogo} />;
    static AppStoreBlackLogo = props => <img alt={'App Store'} src={AppStoreBlackLogo} />;
    static GooglePlayLogo = props => <img alt={'Google Play'} src={GooglePlayLogo} />;
    static GooglePlayComingSoonLogo = props => <img alt={'Google Play'} src={GooglePlayComingSoonLogo} />;

    static CheckEmail = props => <CheckEmail {...props} />;

    static SearchLoop = props => <SearchLoop {...props} />;
    static SearchCloseIcon = props => <SearchCloseIcon {...props} />;
    static SearchNotFound = props => <SearchNotFound {...props} />;
    static SearchUserDefaultImage = props => <SearchUserDefaultImage {...props} />;
    static Settings = props => <Settings {...props} />;
    static Copy = props => <Copy {...props} />;
    static ArrowUp = props => <ArrowUp {...props} />;
    static ArrowDown = props => <ArrowDown {...props} />;
    static Celebrate = props => <Celebrate {...props} />;
    static NoWatch = props => <NoWatch {...props} />;

    // gymtv
    static HeartratePercentWhite = props => <img alt={'Heartrate percentage'} src={HeartratePercentWhite} />;
    static HeartratePercentPurple = props => <img alt={'Heartrate percentage'} src={HeartratePercentPurple} />;
    static HeartratePercentBlue = props => <img alt={'Heartrate percentage'} src={HeartratePercentBlue} />;
    static HeartratePercentGreen = props => <img alt={'Heartrate percentage'} src={HeartratePercentGreen} />;
    static HeartratePercentOrange = props => <img alt={'Heartrate percentage'} src={HeartratePercentOrange} />;
    static HeartratePercentRed = props => <img alt={'Heartrate percentage'} src={HeartratePercentRed} />;

    static CaloriesWhite = props => <img alt={'Calories'} src={CaloriesWhite} />;
    static CaloriesPurple = props => <img alt={'Calories'} src={CaloriesPurple} />;
    static CaloriesBlue = props => <img alt={'Calories'} src={CaloriesBlue} />;
    static CaloriesGreen = props => <img alt={'Calories'} src={CaloriesGreen} />;
    static CaloriesOrange = props => <img alt={'Calories'} src={CaloriesOrange} />;
    static CaloriesRed = props => <img alt={'Calories'} src={CaloriesRed} />;

    static HeartrateWhite = props => <img alt={'Heartrate'} src={HeartrateWhite} />;
    static HeartratePurple = props => <img alt={'Heartrate'} src={HeartratePurple} />;
    static HeartrateBlue = props => <img alt={'Heartrate'} src={HeartrateBlue} />;
    static HeartrateGreen = props => <img alt={'Heartrate'} src={HeartrateGreen} />;
    static HeartrateOrange = props => <img alt={'Heartrate'} src={HeartrateOrange} />;
    static HeartrateRed = props => <img alt={'Heartrate'} src={HeartrateRed} />;

    // workout types
    static Aerobics = props => <img alt={'Workout type'} src={Aerobics} />;
    static AnimalMovement = props => <img alt={'Workout type'} src={AnimalMovement} />;
    static Barre = props => <img alt={'Workout type'} src={Barre} />;
    static Bodyweight = props => <img alt={'Workout type'} src={Bodyweight} />;
    static Bootcamp = props => <img alt={'Workout type'} src={Bootcamp} />;
    static Boxing = props => <img alt={'Workout type'} src={Boxing} />;
    static Calisthenics = props => <img alt={'Workout type'} src={Calisthenics} />;
    static Cardio = props => <img alt={'Workout type'} src={Cardio} />;
    static CircuitTraining = props => <img alt={'Workout type'} src={CircuitTraining} />;
    static Conditioning = props => <img alt={'Workout type'} src={Conditioning} />;
    static Core = props => <img alt={'Workout type'} src={Core} />;
    static Crossfit = props => <img alt={'Workout type'} src={Crossfit} />;
    static Cycling = props => <img alt={'Workout type'} src={Cycling} />;
    static Gym = props => <img alt={'Workout type'} src={Gym} />;
    static HIIT = props => <img alt={'Workout type'} src={HIIT} />;
    static Kettlebell = props => <img alt={'Workout type'} src={Kettlebell} />;
    static MartialArts = props => <img alt={'Workout type'} src={MartialArts} />;
    static Military = props => <img alt={'Workout type'} src={Military} />;
    static Other = props => <img alt={'Workout type'} src={Other} />;
    static Pilates = props => <img alt={'Workout type'} src={Pilates} />;
    static Rowing = props => <img alt={'Workout type'} src={Rowing} />;
    static Running = props => <img alt={'Workout type'} src={Running} />;
    static Spinning = props => <img alt={'Workout type'} src={Spinning} />;
    static StrengthTraining = props => <img alt={'Workout type'} src={StrengthTraining} />;
    static Stretching = props => <img alt={'Workout type'} src={Stretching} />;
    static Strongman = props => <img alt={'Workout type'} src={Strongman} />;
    static Swimming = props => <img alt={'Workout type'} src={Swimming} />;
    static Tabata = props => <img alt={'Workout type'} src={Tabata} />;
    static TRX = props => <img alt={'Workout type'} src={TRX} />;
    static Walking = props => <img alt={'Workout type'} src={Walking} />;
    static WaterAerobics = props => <img alt={'Workout type'} src={WaterAerobics} />;
    static WeightTraining = props => <img alt={'Workout type'} src={WeightTraining} />;
    static Yoga = props => <img alt={'Workout type'} src={Yoga} />;

    static CaretRight = props => <img alt={'Right'} src={CaretRight} />;
    static CheckOrange = props => <CheckOrange {...props} />;
    static CaretLeft = props => <img alt={'Left'} src={CaretLeft} />;

    render() {
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/UI/Components/Icons/Icons.js